module.exports = __webpack_public_path__ + "media/images/icons/dashboard-75d0adffbc120c6043d04f4083f70fb2.svg";